<template>
  <div class="container">
    <span class="toggle-button" @click="toggleFoldBtn">
      <i class="el-icon el-icon-ali-shouqi" :class="{fold: sideBarFold}"></i>
    </span>
    <h3 class="title">{{ subtitle }}</h3>
    <span class="avatar-box">
      <regionTargetBtn class="btn-wrapper"></regionTargetBtn>
      <serverPoint class="btn-wrapper" v-if="userGroup === 1000"></serverPoint>
      <trainTaskListBtn
        class="btn-wrapper"
        v-if="userGroup === 1000"
      ></trainTaskListBtn>
      <downloadImageButton
        class="btn-wrapper"
        v-if="userGroup === 1000"
      ></downloadImageButton>
      <el-dropdown class="btn-wrapper" @command="handleDropDown" trigger="click">
        <span class="el-dropdown-link">
          <el-button type="text">
            {{ username }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout">注销</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </span>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import trainTaskListBtn from './trainTaskListBtn';
import serverPoint from './serverPoint';
import regionTargetBtn from '_v/region/regionTargetBtn';
import downloadImageButton from './downLoadImages';

export default {
  name: "headerBar",
  components: {
    trainTaskListBtn,
    serverPoint,
    downloadImageButton,
    regionTargetBtn
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    ...mapActions([]),
    toggleFoldBtn () {
      this.$store.dispatch('toggleSideBar');
    },
    logout() {
      this.$store.dispatch("clearUserinfo");
      this.$router.push("/login");
    },
    handleDropDown(command) {
      switch (command) {
        case "logout":
          this.logout();
          break;
        case "setting":
          this.setting();
          break;
      }
    }
  },
  computed: {
    ...mapGetters(["userinfo", "subtitle", 'sideBarFold']),
    userGroup() {
      return this.userinfo().userGroup;
    },
    username() {
      return this.userinfo().username;
    }
  },
  watch: {}
};
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  overflow: hidden;
  position: relative;
  height: 40px;
  /*border-bottom: 1px solid #ccc;*/
  box-shadow: 0 1px 4px 0 rgba(0, 21, 41, 0.08);
  .toggle-button {
    display: inline-block;
    width: 40px;
    height: 40px;
    cursor: pointer;
    text-align: center;
    .el-icon {
      font-size: 18px;
      line-height: 40px;
      transition: transform .5s;
      &.fold {
        transform: rotate(180deg)
      }
    }
    &:hover {
      background-color: rgba(0, 21, 41, 0.08);
      .el-icon {
        color: $primary;
      }
    }
  }
  .title {
    display: inline-block;
    line-height: 40px;
    margin: 0;
  }
  .avatar-box {
    position: absolute;
    display: inline-block;
    right: 0;
    height: 100%;
    line-height: 40px;
    .icon {
      font-size: 24px;
    }
    .btn-wrapper {
      text-align: center;
      display: inline-block;
      padding-right: 20px;
      line-height: 40px;
      vertical-align: top;
      .dropdown {
        vertical-align: top;
      }
    }
  }
}
</style>
